import { MenuItem, Select, SelectChangeEvent, styled, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { EconsultUtils } from '@oh-vcp/components-common';

const containerWidth = EconsultUtils.isMobileDevice() ? '94%' : '100%';
const SelectContainer = styled(Select)({
  height: 30,
  width: containerWidth,
  paddingTop: 5,
  '& .MuiSelect-icon': {
    backgroundColor: 'white',
    right: '0px'
  }
});

interface EconsultProgramSelectorProps {
  options: string[];
  onSelected: (programName: string) => void;
  selectedProgramName: string;
}

const EconsultProgramSelector: FC<EconsultProgramSelectorProps> = ({
  options,
  onSelected,
  selectedProgramName
}) => {
  const [myHeight, setMyHeight] = useState<number>(30);
  const handleChange = (e: SelectChangeEvent<unknown>) => {
    setMyHeight(30);
    onSelected(e.target.value as string);
  };
  return (
    <SelectContainer
      MenuProps={{
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        }
      }}
      value={selectedProgramName}
      onChange={handleChange}
      style={{ height: myHeight }}>
      <MenuItem
        value="0"
        sx={{
          '&.Mui-selected:hover': { color: 'black' }
        }}>
        <Typography variant="body2">All Groups</Typography>
      </MenuItem>
      {options.map((o, i) => (
        <MenuItem value={o} key={i} sx={{ '&.Mui-selected:hover': { color: 'black' } }}>
          <Typography
            variant="body2"
            noWrap
            style={{ overflow: 'hidden', textOverflow: 'clip' }}>
            {o}
          </Typography>
        </MenuItem>
      ))}
    </SelectContainer>
  );
};

export default EconsultProgramSelector;
